import emptyState from "./emptyState";
import { actionTypes } from "./actions";
import { immutableSet } from "../../../../utils/immutable";
import { IAction } from "../../../../models/Action";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { compose } from "redux";
import {
  STATE_IDENTIFIER,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
} from "./constants";

const {
  STEP_ONE,
  STEP_TWO,
  TEMPLATE_MAIL_TABLE,
  TEMPLATE_MAIL_DETAIL,
  REQUEST_STATE,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.MAIL_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [STEP_ONE, TEMPLATE_MAIL_TABLE, LOADER_IDENTIFIER],
      true,
      state
    ),
  [actionTypes.MAIL_REQUEST_SUCCESS]: (state: any, action: any) => {
    let mappedResponse: any[] = [];
    action.payload.templates.length > 0 &&
      action.payload.templates.forEach((data: any) => {
        const tempRow: {} = {
          id: data.id,
          operation: data.operation,
          subject: data.subject,
          to: data.to,
          cc: data.cc,
          ccn: data.ccn,
          body: data.body,
          max_retry: data.maxRetry,
          retry_delay: data.retryDelay,
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet(
        [STEP_ONE, TEMPLATE_MAIL_TABLE, LIST_IDENTIFIER],
        mappedResponse
      ),
      immutableSet([STEP_ONE, TEMPLATE_MAIL_TABLE, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.MAIL_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [STEP_ONE, TEMPLATE_MAIL_TABLE, LOADER_IDENTIFIER],
      false,
      state
    ),

  [actionTypes.MAIL_DETAIL_REQUEST]: (state: any, action: any) => {
    return compose(
      immutableSet(
        [STEP_TWO, TEMPLATE_MAIL_DETAIL, LIST_IDENTIFIER],
        action.payload
      ),
      immutableSet([STEP_TWO, TEMPLATE_MAIL_DETAIL, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.CREATE_TEMPLATE_MAIL]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.CREATE_TEMPLATE_MAIL_SUCCESS]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypes.CREATE_TEMPLATE_MAIL_FAILURE]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.MODIFY_TEMPLATE_MAIL]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.MODIFY_TEMPLATE_MAIL_SUCCESS]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypes.MODIFY_TEMPLATE_MAIL_FAILURE]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.RESET_MAIL_DETAIL]: (state: any, action: any) => {
    return compose(
      immutableSet([STEP_TWO, TEMPLATE_MAIL_DETAIL, LIST_IDENTIFIER], []),
      immutableSet([STEP_TWO, TEMPLATE_MAIL_DETAIL, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.RESET_STATE_TEMPLATE_MAIL_MANAGEMENT]: (
    state: any,
    action: any
  ) => emptyState,
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
